<template>
  <div class="work">
    <div class="header pure-u-1" :style="{backgroundImage:'url('+ work.acf.topImg +')'}">
      <div class="msk"></div>
      <div class="title">{{work.title.rendered?work.title.rendered:''}}</div>
    </div>
    <div class="pure-g page-work">
      <div class="entry content">
        <div class="top">
          <div class="pure-g in">
            <div class="pure-u-1 pure-u-md-1-3" style="text-align:center">
              <div class="inner">
                <h3>{{work.title.rendered?work.title.rendered:''}}</h3>
              </div>
            </div>
            <div class="pure-u-2 pure-u-md-2-3">
              <div class="inner" v-html="work.acf.intro?work.acf.intro:''"></div>
            </div>
          </div>
        </div>
        <div class="more">
          <div class="pure-g in">

            <div class="pure-u-1-2 pure-u-md-1-4">
              <p>
                客户<br/>{{work.acf.clients?work.acf.clients:'-'}}
              </p>
            </div>
            <div class="pure-u-1-2 pure-u-md-1-4">
              <p>
                年份<br/>{{work.acf.years?work.acf.years:'-'}}
              </p>
            </div>
            <div class="pure-u-1-2 pure-u-md-1-4" >
              <p>
                类别<br/>{{work.acf.type?work.acf.type:'-'}}
              </p>
            </div>
            <div class="pure-u-1-2 pure-u-md-1-4" >
              <p>
                负责内容<br/>{{work.acf.content?work.acf.content:'-'}}
              </p>
            </div>

          </div>
        </div>
        <div class="inner entry-content" v-html="work.content.rendered?work.content.rendered:''"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Work",
  data() {
    return {
      work: {},
    };
  },
  mounted() {
    console.log(this.$route.params.name);
    this.axios
      .get(
        "https://api.rocidesign.com/wp-json/wp/v2/projects/" +
          this.$route.params.name
      )
      .then((response) => {
        console.log(response.data);
        this.work = response.data;
      });
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.header {
  height: 100vh;
  width: 100%;
  text-align: center;
  background-position: center center;
  background-size: cover;
  position: relative;
  color: #fff;
  font-size: 4em;
}
.header .title {
  line-height: 100vh;
  position: relative;
}
.header .msk {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
#content{
    left: 0 !important;
}
</style>